<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
  <div slot="body">
      <bita-form ref="form">
          <div slot="body">
                <div class="row">
                    <bita-input
                        type="text"
                        name="amount"
                        ref="amount"
                        label="مبلغ"
                        input-class="form-control"
                        validation-container-class="col-3"
                        :has-thousand-seprator="true"
                        v-model="formData.amount"
                        :disabled="disabled"
                    />
                    <bita-input
                        type="text"
                        name="tracking_code"
                        ref="trackingcode"
                        label="کد پیگیری"
                        input-class="form-control"
                        validation-container-class="col-3"
                        v-model="formData.tracking_code"
                        :disabled="disabled"
                    />
                    <bita-input
                        type="text"
                        name="card_number"
                        ref="cardnumber"
                        label="واریز به"
                        input-class="form-control"
                        validation-container-class="col-3"
                        v-model="formData.card_number"
                        :disabled="disabled"
                    />
                    <bita-datepicker
                        type="date"
                        id="paymentat"
                        validation-container-class="col-3"
                        name="paymentat"
                        label="زمان پرداخت"
                        inputClass="form-control"
                        v-model="formData.payment_at"
                        :disabled="disabled"
                    />
                    <bita-input
                        type="text"
                        name="user_id"
                        ref="user_id"
                        label="واریز به شخص"
                        input-class="form-control"
                        validation-container-class="col-3"
                        v-model="propsUser"
                        :disabled="disabled"
                    />
                    <bita-input
                        type="text"
                        name="depositor_name"
                        ref="depositor_name"
                        label="نام - نام خانوادگی واریز کننده"
                        input-class="form-control"
                        validation-container-class="col-3"
                        v-model="formData.depositor_full_name"
                        :disabled="disabled"
                    />
                    <bita-input
                        type="text"
                        name="depositor_national_code"
                        ref="depositor_national_code"
                        label="کد ملی واریز کننده"
                        input-class="form-control"
                        validation-container-class="col-3"
                        v-model="formData.depositor_national_code"
                        :disabled="disabled"
                    />
                    <bita-input
                        type="text"
                        name="description"
                        ref="description"
                        label="توضیحات"
                        input-class="form-control"
                        validation-container-class="col-3"
                        v-model="formData.description"
                        :disabled="disabled"
                    />
                </div>
          </div>
      </bita-form>
      <div slot="footer">
        <bita-bootbutton
        type="primary"
        title="ثبت فیش"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="createGateway()"
        />
      </div>
  </div>
  </bita-modal>
</template>
<script>
export default {
    props: {
        modalId: {},
        title: {},
        isLoading: {},
        propsData: {},
        propsUser: {},
    },
    data() {
        return {
            disabled: true,
            formData: {},
        }
    },
    watch: {
        propsData: function(_data){
            this.formData = _data;
        },
    },
    methods: {
        onCloseModal() {

        },
        createGateway() {
            this.$emit("on-submit", this.formData);
        },
    }
}
</script>